import React from 'react';

const Loader = () => (
  <div className='d-flex justify-content-center align-items-center w-100 h-100'>
    <div className='spinner-border' role='status' />
  </div>
);

export default Loader;
